import { __awaiter, __generator } from "tslib";
import { createSimpleStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getUserStorageItem } from './getUserStorageItem';
var userStoragePersistenceKey = 'userStorage';
var userStoragePersistenceVersion = 1; // TODO: Should we be able to version by key?
export function executeUserStorageDataFlow(storageKey, identity, officeComponentContext, handleRevalidation, forceRefresh, remoteAttempts) {
    return __awaiter(this, void 0, void 0, function () {
        var options, itemPersistenceKey;
        return __generator(this, function (_a) {
            options = {
                correlationId: officeComponentContext.correlationId,
                getAccessToken: officeComponentContext.getAccessToken,
                getIdentity: function () { return Promise.resolve(identity); },
                inMockMode: officeComponentContext.inMockMode,
                jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                workload: officeComponentContext.workload,
            };
            itemPersistenceKey = "".concat(userStoragePersistenceKey, "-").concat(storageKey);
            return [2 /*return*/, createSimpleStaleWhileRevalidateOperation(function () {
                    return getUserStorageItem(storageKey, options, forceRefresh, remoteAttempts);
                }, function () {
                    return readFromSimplePersistence({
                        userId: identity.puid,
                        collectionName: userStoragePersistenceKey,
                        collectionVersion: userStoragePersistenceVersion,
                        key: itemPersistenceKey,
                    });
                }, function (networkPayload) {
                    return writeToSimplePersistence({
                        userId: identity.puid,
                        collectionName: userStoragePersistenceKey,
                        collectionVersion: userStoragePersistenceVersion,
                        key: itemPersistenceKey,
                        data: networkPayload,
                    });
                }, handleRevalidation)];
        });
    });
}
//# sourceMappingURL=executeUserStorageDataFlow.js.map